module.exports = __webpack_public_path__ + "img/star-gray.bbf70e21.svg";